<template>
    <modal v-if="$root.showModal">
        <div
            slot="header"
            class="col-12">
            <h4
                class="modal-title box-title"
                style="line-height: 36px">
                Ustvari novo sekcijo
            </h4>
            <button
                type="button"
                class="close"
                aria-label="Zapri"
                @click.prevent="$root.closeModal">
                <span aria-hidden="true">×</span>
            </button>
        </div>
        <div slot="body">
            <form
                role="form"
                @submit.prevent="addItem">
                <div class="box-body">
                    <div class="form-group">
                        <label for="name">Ime</label>
                        <input
                            id="name"
                            v-model="newItem.name"
                            type="text"
                            class="form-control"
                            placeholder="Ime"
                            required>
                    </div>
                </div>
                <div class="box-footer">
                    <button
                        type="submit"
                        class="btn btn-success">Shrani
                    </button>
                </div>
            </form>
        </div>
    </modal>
</template>

<script>
import Modal   from './../Modal.vue';
import NewItem from '../../mixins/NewItem';

export default {
    name: 'NewSection',

    components: {
        Modal
    },

    mixins: [
        NewItem
    ],

    data() {
        return {
            newItem: {
                name: null
            }
        };
    },

    methods: {
        prepareNewItemData() {
            return {
                name: this.newItem.name
            };
        },

        resetNewItem() {
            this.$set(this.newItem, 'name', null);
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/Sections/NewSection.vue